import React, {useEffect, useState} from 'react'
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import ReactTable from "../../Components/ReactTable";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {getNicelyFormattedNumber} from "../../../utils/formatUtil";
import RetailerIdAndName from "../../Components/RetailerIdAndName";
import {getRetailerName} from "../../../utils/localCache/retailerMapCache";

export const COMPLETENESS_COLUMNS = [
    {
        header: 'Retailer',
        accessorKey: 'retailerId',
        cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,
        className: 'non-numeric-field',
        filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.retailerId} ${getRetailerName(row.original.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase()))

    },
    {
        header: 'Cleansed Stores With Sales',
        accessorKey: 'cleansedStoresWithSales',
        enableColumnFilter: false,
        className: 'numeric-field'
    },
    {
        header: 'Filled Stores With Sales',
        accessorKey: 'fillStoresWithSales',
        enableColumnFilter: false,
        className: 'numeric-field'
    },
    {
        header: 'Total Stores',
        accessorKey: 'storeCount',
        enableColumnFilter: false,
        className: 'numeric-field'
    },
    {
        header: 'Cleansed Weeks',
        accessorKey: 'cleansedWeeks',
        enableColumnFilter: false,
        className: 'numeric-field'
    },
    {
        header: 'Filled Weeks',
        accessorKey: 'fillWeeks',
        enableColumnFilter: false,
        className: 'numeric-field'
    },
    {
        header: 'Cleansed Total Record Count',
        accessorKey: 'cleansedRecordCount',
        enableColumnFilter: false,
        className: 'numeric-field',
        cell: ({getValue}) => getNicelyFormattedNumber(getValue())
    },
    {
        header: 'Filled Total Record Count',
        accessorKey: 'fillRecordCount',
        enableColumnFilter: false,
        className: 'numeric-field',
        cell: ({getValue}) => getNicelyFormattedNumber(getValue())
    },
    {
        header: 'Cleansed Dollars',
        accessorKey: 'cleansedSalesAmount',
        enableColumnFilter: false,
        className: 'numeric-field',
        cell: ({getValue}) => getNicelyFormattedNumber(getValue())
    },
    {
        header: 'Filled Dollars',
        accessorKey: 'fillSalesAmount',
        enableColumnFilter: false,
        className: 'numeric-field',
        cell: ({getValue}) => getNicelyFormattedNumber(getValue())
    }
]

export const completenessQuery = `{
    completeness {
            name
            cleansedWeeks
            fillWeeks
            retailerId
            storeCount
            fillRecordCount
            fillSalesAmount
            cleansedRecordCount
            cleansedSalesAmount
            fillStoresWithSales
            cleansedStoresWithSales
        }
    }`

const CompletenessPage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(undefined);
    const [error, setError] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        makeApolloClientCall(completenessQuery)
            .then(results => setData(results))
            .catch(() => {
                setError('completeness Query Failed, Please Try Again');
                setLoading(false);
            })
            .finally(() => setLoading(false));
    }, [])

    return <Page name={'Ingestion Completeness'}
                 breadCrumbs={<Breadcrumbs items={[{label: 'Retailer Readiness'}, {label: 'Completeness'}]}/>}>
        <LoadingWrapper loading={loading}>
            {data && <ReactTable
                filterable
                data={data.completeness}
                columns={COMPLETENESS_COLUMNS}
            />}
            {error && <div className={'error-message-wrapper'} data-testid={'error-message'}>{error}</div>}
        </LoadingWrapper>
    </Page>;
}

export default CompletenessPage;
